export enum StaticDictionaryName {
  Voivodeship = 'voivodeship',
  CarElementType = 'carElementType',
  ClaimStatus = 'claimStatus',
  ClaimType = 'claimType',
  ClaimSubType = 'claimSubType',
  ClaimDocumentationType = 'claimDocumentationType',
  Country = 'country',
  CompensationTarget = 'compensationTarget',
  TaxDeduction = 'taxDeduction',
  ProofDocumentType = 'proofDocumentType',
  ProofDocumentKind = 'proofDocumentKind',
  ProofDocumentConformity = 'proofDocumentConformity',
  ProofDocumentRequiredFrom = 'proofDocumentRequiredFrom',
  InspectionType = 'inspectionType',
  InspectionStatus = 'inspectionStatus',
  CostEstimationStatus = 'costEstimationStatus',
  CostEstimationType = 'costEstimationType',
  DocumentDefintionIdName = 'documentDefintionIdName',
  CarBodyType = 'carBodyType',
  CarColorType = 'carColorType',
  ClaimPersonRoleType = 'claimPersonRoleType',
  RepairMode = 'repairMode',
  GlassBreakageType = 'glassBreakageType',
  ReplacementCarType = 'replacementCarType',
  ReplacementCarNeeded = 'replacementCarNeeded',
  Door2DoorType = 'door2DoorType',
  orderingPartyType = 'orderingPartyType',
  claimStage = 'claimStage',
  claimStageCommand = 'claimStageCommand',
  claimStageHelp = 'claimStageHelp',
  claimStageCommandHelp = 'claimStageCommandHelp',
  PersonType = 'personType',
  AgreementType = 'agreementType',
  SearchAudanetTasksType = 'searchAudanetTasksType',
  FinancingType = 'financingType',
  cancelClaimReason = 'cancelClaimReason',
  driverContactResult = 'driverContactResult',
  reminderType = 'reminderType',
  sendingChannelType = "sendingChannelType",
  repairStatus = 'repairStatus',
  repairAssemblyStatus = 'repairAssemblyStatus',
  repairAssemblyType = 'repairAssemblyType',
  repairType = 'repairType',
  notesType = 'notesType',
  repairAssemblyElement = 'repairAssemblyElement',
  claimActivityReferenceType = 'claimActivityReferenceType',
  costInvoiceDocumentType = 'costInvoiceDocumentType',
  provisionType = 'provisionType',
  provisionCalculationType = 'provisionCalculationType',
  costInvoiceType = 'costInvoiceType',
  workshopAccessMode = 'workshopAccessMode',
  claimStageGroupType = 'claimStageGroupType',
  invoiceType = 'invoiceType',
  vatRate = 'vatRate',
  carRentStatus = 'carRentStatus',
  carRentMode = 'carRentMode',
  paymentDeclarationStatus = 'paymentDeclarationStatus',
  paymentMethod = 'paymentMethod',
  InsuranceType = 'insuranceType',
  BusinessTripStatus = "businessTripStatus",
  partsDepreciationState = 'partsDepreciationState',
  vatPayerState = 'vatPayerState',
  ClaimMassSearchType = 'claimMassSearchType',
  ksefOperationStatus = 'ksefOperationStatus',
  inspectionCardCalculatorType = 'inspectionCardCalculatorType',
}
